import { Helmet } from "react-helmet";
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
  Radio,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom'
import { useEffect, useState } from "react";

import { ReactComponent as BackIcon } from "../../../icons/arrow-left.svg";

const MyGoalChooseCreate = (props) => {
  const { t } = useTranslation();
  const [selectLibrary, setLibrary] = useState(1);
  const navigate = useNavigate();
  const { state } = useLocation();
  const styles = {
    link: {
      color: "#5DA196",
      cursor: "pointer",
    },
    end: {
      color: "#A3A3A3",
    },
  };

  const chooseLibrary = (val) => {
    setLibrary(val)
  }
  const goto = (path, data) => {
    if (path) {
      if (path === 'mygoal' && state.isEvaluator && state.formEvaluateId) path += '/' + state.formEvaluateId

      path = '/' + path
    }

    navigate("/kpi" + path, { replace: false, state: data });
  }
  const gotoCreateForm = () => {
    Object.assign(state, {
      name: undefined,
      librarySerial: undefined,
      description: undefined,
      category: undefined,
      librarySerial: undefined,
      metric: undefined
    });
    if (selectLibrary == 1) {
      goto('mygoal-create/quick', state)
    } else if (selectLibrary == 2) {
      goto('mygoal-choose-type', state)
    } else if (selectLibrary == 3) {
      goto('mygoal-choose-library', state)
    }
  }

  const getTitle = () => {
    let title = t('mygoal.page.mygoal')

    if (state.isEvaluator && state.owner?.firstname) {
      title = state.owner.firstname + ' ' + state.owner.lastname
      title += '\'s ' + t('label.goal')
    }

    return title
  }

  return (
    <>
      <Helmet>
        <title>MyGoalDetail | KPI </title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: "background.default",
          minHeight: "100%",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Grid container pt={2} pb={2}>
            <Typography fontSize={16} lineHeight={1} color="#68717A">
              <span style={styles.link} onClick={() => goto('home')}>
                {t('label.home')}
              </span> /
              <span style={styles.link} onClick={() => goto('mygoal', state)}>
                {` ${getTitle()}`}
              </span> /
              <span style={styles.end} >
                {` ${t('mygoal.page.libraryGoal')} `}
              </span>
            </Typography>
          </Grid>
          {/* start portfoliio 10*/}
          {/* <Grid container item> */}
          <Grid container textAlign="center">
            <Grid item md={12} >
              <Typography variant="h1" fontSize={32} lineHeight="39.6px" fontWeight="600" color="#404349">
                {t('mygoal.label.titleCreateGoal')}
              </Typography>
            </Grid>
            <Grid item md={12} pr={1} mt={1} mb={3}>
              <Typography fontSize={16} fontWeight={400} color="#404349">
                {t('mygoal.label.createGoalSub')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={6} pl={3} pr={3}>
            <Grid lg={4} xs={12} item>
              <Card style={selectLibrary === 1 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { cursor: 'pointer' }} onClick={() => { chooseLibrary(1) }}>
                <CardContent>
                  <Grid item lg={12} xs={12} container textAlign="center">
                    <Grid item>
                      <Radio name="radio" value="1" checked={selectLibrary === 1} size="small" />
                    </Grid>
                    <Grid item lg={12}>
                      {selectLibrary === 1 ? <img src={require('../../../icons/goal-quick-active.svg').default} /> : <img src={require('../../../icons/goal-quick-inactive.svg').default} />}
                    </Grid>
                    <Grid item lg={12} mt={3.5}>
                      <Typography fontSize={22} lineHeight="21px" fontWeight="500" color="#404349">
                        {t('mygoal.label.quickGoal')}
                      </Typography>
                    </Grid>
                    <Grid item lg={12} mt={2} mb={3.5}>
                      <Typography fontSize={13} fontWeight="400" color="#A3A3A3">
                        {t('mygoal.label.quickGoalSub')}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid lg={4} xs={12} item>
              <Card style={selectLibrary === 2 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { cursor: 'pointer' }} onClick={() => { chooseLibrary(2) }}>
                <CardContent >
                  <Grid item lg={12} xs={12} container textAlign="center">
                    <Grid item>
                      <Radio name="radio" value="2" checked={selectLibrary === 2} size="small" />
                    </Grid>
                    <Grid item lg={12}>
                      {selectLibrary === 2 ? <img src={require('../../../icons/goal-guide-active.svg').default} /> : <img src={require('../../../icons/goal-guide-inactive.svg').default} />}
                    </Grid>
                    <Grid item lg={12} mt={3}>
                      <Typography fontSize={22} lineHeight="21px" fontWeight="500" color="#404349">
                        {t('mygoal.label.goalGuide')}
                      </Typography>
                    </Grid>
                    <Grid item lg={12} mt={2} mb={3}>
                      <Typography fontSize={13} fontWeight="400" color="#A3A3A3">
                        {t('mygoal.label.goalGuideSub')}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid lg={4} xs={12} item>
              <Card style={selectLibrary === 3 ? { border: '1px solid #5DA196', cursor: 'pointer' } : { cursor: 'pointer' }} onClick={() => { chooseLibrary(3) }}>
                <CardContent>
                  <Grid item lg={12} xs={12} container textAlign="center">
                    <Grid item>
                      <Radio name="radio" value="3" checked={selectLibrary === 3} size="small" />
                    </Grid>
                    <Grid item lg={12}>
                      {selectLibrary === 3 ? <img src={require('../../../icons/goal-library-active.svg').default} /> : <img src={require('../../../icons/goal-library-inactive.svg').default} />}
                    </Grid>
                    <Grid item lg={12} mt={4.5}>
                      <Typography fontSize={22} lineHeight="21px" fontWeight="500" color="#404349">
                        {t('mygoal.label.goalLibrary')}
                      </Typography>
                    </Grid>
                    <Grid item lg={12} mt={2}>
                      <Typography fontSize={13} fontWeight="400" color="#A3A3A3">
                        {t('mygoal.label.goalLibrarySub')}
                      </Typography>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid container direction="row" style={{ marginTop: '85px' }}>
              <Grid container lg={1} xs={1} direction="row" style={{ alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => goto('mygoal', state)}>
                <Grid item mt={0.5}>
                  <BackIcon />
                </Grid>
                <Grid item ml={1}>
                  <Typography fontWeight={500} fontSize={18} color={'#6B6B6B'}>
                    {t('label.back')}
                  </Typography>
                </Grid>
              </Grid>
              <Grid lg={10} xs={12} item textAlign="center">
                <Button
                  size="small"
                  aria-controls="simple-menu"
                  aria-haspopup="true"
                  onClick={() => { gotoCreateForm() }}
                  color="primary"
                  variant="contained"
                  style={{ paddingLeft: 30, paddingRight: 30, textTransform: 'none', backgroundColor: selectLibrary === null ? '#BABABA' : '#5DA196' }}
                >
                  <Typography fontWeight={500} fontSize={18} color={'#FFFFFF'}>{t("label.next")}</Typography>
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};
export default MyGoalChooseCreate;
